(function () {
  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }

  var CART = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 4h2.2l2.3 10.2a1.5 1.5 0 0 0 1.5 1.2h8.1a1.5 1.5 0 0 0 1.5-1.1L20.5 8H6.2"/><circle cx="9.5" cy="19.5" r="1.4"/><circle cx="17" cy="19.5" r="1.4"/></svg>';

  function build() {
    var pm = q('.price-meta');
    var pre = pm && pm.querySelector('.msd-rates');
    if (!pm || (pre && pre.dataset.b)) return;
    var row = q('.price-meta__row', pm),
        inst = q('.installment-banks', pm),
        tbi = q('.tbi-rate', pm),
        rate = inst && q('[data-pm-rate]', inst);
    if (!row || (!rate && !tbi)) return;

    // tbi peste pragul de 2.000 lei: rate pe 6–60 luni (cu dobândă), nu 4 rate 0%
    function tbiBig() {
      return !!tbi && +tbi.dataset.price > +tbi.dataset.promo && !tbi.classList.contains('tbi-rate--hidden');
    }
    function tbiStrong() { return tbi && q('[data-tbi-text] strong', tbi) || (tbi && q('strong', tbi)); }
    function stripTbi(html) {
      return (html || '')
        .replace(/^\s*de la\s*/i, '')
        .replace(/^\s*\d+\s*rate\s*x\s*/i, '')
        .replace(/\s*lei(\/lun[ăa])?\s*$/i, '')
        .replace(/\s+(<sup)/gi, '$1')
        .trim().replace(/^([\d.]+)(?=<sup)/, '<span class="pm-int">$1</span>');
    }

    // rândul de rate vine randat din Liquid (fără salt la încărcare); îl creăm doar dacă lipsește
    var box = pre;
    if (!box) {
      box = document.createElement('div');
      box.className = 'msd-rates';
      box.innerHTML = '<span class="msd-rates__k">Rate lunare de la</span><b class="msd-rates__v"><span data-msd-rate></span> lei</b><button type="button" class="msd-rates__more">vezi detalii</button>';
      row.appendChild(box);
    }
    box.dataset.b = '1';
    var v = q('[data-msd-rate]', box);

    function sync() {
      if (tbiBig()) {
        var s = tbiStrong();
        v.innerHTML = s ? stripTbi(s.innerHTML) : '';
      } else if (rate) {
        v.innerHTML = rate.innerHTML;
      } else {
        var s2 = tbiStrong();
        v.innerHTML = s2 ? stripTbi(s2.innerHTML) : '';
      }
    }
    sync();
    var mo = new MutationObserver(sync);
    if (rate) mo.observe(rate, { childList: true, subtree: true, characterData: true });
    if (tbi) mo.observe(tbi, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-price', 'class'] });
    if (inst) inst.classList.add('msd-hide');
    if (tbi) tbi.classList.add('msd-hide');

    var m = document.createElement('div');
    m.className = 'msd-rm';
    m.hidden = true;
    m.innerHTML =
      '<div class="msd-rm__bg" data-x></div>' +
      '<div class="msd-rm__box" role="dialog" aria-modal="true" aria-label="Cumpără în rate">' +
        '<div class="msd-rm__top"><h3>Cumpără în rate</h3><button type="button" class="msd-rm__x" data-x aria-label="Închide">×</button></div>' +
        '<div class="msd-rm__body">' +
          '<div class="msd-rm__prod"><img alt=""><div><b data-t></b><span class="msd-rm__price" data-p></span></div></div>' +
          (inst ?
            '<section class="msd-rm__sec" data-card>' +
              '<div class="msd-rm__hd"><b>Rate fără dobândă cu cardul</b><span class="msd-rm__brand">NETOPIA Payments</span></div>' +
              '<div class="msd-rm__tabs" data-tabs></div>' +
              '<div class="msd-rm__opt is-on"><i class="msd-rm__radio"></i><div class="msd-rm__txt"><b>Card de credit al băncilor partenere</b><small>Rata lunară: <span data-cr></span> • Dobândă: 0%</small></div><span class="msd-rm__tag">0% dobândă</span></div>' +
              '<div class="msd-rm__banks" data-banks></div>' +
              '<p class="msd-rm__note">Alegi numărul de rate la pasul de plată, în pagina securizată NETOPIA Payments.</p>' +
            '</section>' : '') +
          (tbi ?
            '<section class="msd-rm__sec" data-tbi>' +
              '<div class="msd-rm__hd"><b>Rate fără card</b></div>' +
              '<div class="msd-tc__lbl" data-tlbl hidden>Alege numărul de rate lunare</div>' +
              '<div class="msd-rm__tabs" data-ttabs hidden></div>' +
              '<div class="msd-rm__opt is-on"><i class="msd-rm__radio"></i><div class="msd-rm__txt"><b>tbi bank</b><small data-tr></small></div><span class="msd-rm__tag msd-rm__tag--promo" data-ttag>Promo</span><img class="msd-rm__logo" alt="tbi bank"></div>' +
              '<dl class="msd-tc" data-tdet hidden></dl>' +
              '<div class="msd-rm__tbi" data-tbiinfo></div>' +
            '</section>' : '') +
        '</div>' +
        '<div class="msd-rm__foot"><button type="button" class="msd-rm__atc"><span class="msd-rm__cart">' + CART + '</span>Adaugă în coș</button></div>' +
      '</div>';
    document.body.appendChild(m);

    var st = document.createElement('style');
    st.textContent =
      '.msd-rates__v{white-space:nowrap}' +
      '.msd-rm [data-ttabs][hidden],.msd-tc[hidden],.msd-tc__lbl[hidden]{display:none!important}' +
      '.msd-tc__lbl{font-size:13px;font-weight:600;color:#3D453B;margin:0 0 6px}' +
      '.msd-rm [data-ttabs]{display:grid!important;grid-template-columns:repeat(7,minmax(0,1fr));gap:6px}' +
      '.msd-rm [data-ttabs] .msd-rm__tab{min-width:0;padding-left:0;padding-right:0;text-align:center}' +
      '.msd-tc{display:grid;grid-template-columns:1fr 1fr;gap:0 16px;margin:10px 0 12px;padding:0}' +
      '.msd-tc div{display:flex;justify-content:space-between;gap:8px;padding:5px 0;border-bottom:1px dashed #D6DDD1;font-size:13px;line-height:1.3}' +
      '.msd-tc dt{margin:0;color:#5A6358}.msd-tc dd{margin:0;font-weight:600;white-space:nowrap;color:#1B1F1A}' +
      '.msd-tc .msd-tc__big{grid-column:1/-1;align-items:baseline;border-bottom:1px solid #D6DDD1}' +
      '.msd-tc .msd-tc__big dd{font-size:20px;font-weight:700;color:#2F4A22}' +
      '@media (max-width:640px){.msd-tc{grid-template-columns:1fr}.msd-rm [data-ttabs]{grid-template-columns:repeat(4,minmax(0,1fr))}}';
    document.head.appendChild(st);

    var grid = inst && q('.installment-banks__grid', inst);
    if (grid) q('[data-banks]', m).appendChild(grid);
    var tl = tbi && q('img', tbi);
    if (tl) q('.msd-rm__logo', m).src = tl.src;

    var tinfo = q('[data-tbiinfo]', m);

    // ---- Calculator tbi bank (oferta Military Shop: comision 95 lei, asigurare 0,2%/lună) ----
    var TBI = { fee: 95, insPct: 0.002, terms: [6, 12, 18, 24, 36, 48, 60],
      schemes: [{ min: 10000, r: 0.18 }, { min: 5000, r: 0.2388 }, { min: 200, r: 0.29 }] };
    var tbiN = 60;
    function nf(x) { return x.toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function lei(x) { return nf(x) + ' lei'; }
    function pct(x) { return nf(x * 100) + '%'; }
    function solveRate(n, pmt, pv) {
      var lo = 1e-9, hi = 1;
      for (var k = 0; k < 200; k++) {
        var mm = (lo + hi) / 2;
        if (pmt * (1 - Math.pow(1 + mm, -n)) / mm > pv) lo = mm; else hi = mm;
      }
      return (lo + hi) / 2;
    }
    function tcalc(S, n) {
      var sc = TBI.schemes.find(function (x) { return S >= x.min; });
      if (!sc) return null;
      var ins = TBI.insPct * (S + TBI.fee) * n, i = sc.r / 12;
      var pmt = (S + TBI.fee + ins) * i / (1 - Math.pow(1 + i, -n));
      return { S: S, n: n, r: sc.r, ins: ins, pmt: pmt, total: pmt * n, dae: Math.pow(1 + solveRate(n, pmt, S + ins), 12) - 1 };
    }

    function renderTbiCalc() {
      var S = +tbi.dataset.price / 100;
      var c = tcalc(S, tbiN), c60 = tcalc(S, 60);
      if (!c || !c60) return;
      q('[data-tr]', m).innerHTML = 'Rata lunară: ' + lei(c.pmt) + ' • ' + tbiN + ' rate • Dobândă fixă: ' + pct(c.r);
      q('[data-tdet]', m).innerHTML =
        '<div class="msd-tc__big"><dt>Rată lunară (' + tbiN + ' luni)</dt><dd>' + lei(c.pmt) + '</dd></div>' +
        '<div><dt>Valoare finanțată</dt><dd>' + lei(c.S) + '</dd></div>' +
        '<div><dt>Dobândă anuală fixă</dt><dd>' + pct(c.r) + '</dd></div>' +
        '<div><dt>DAE</dt><dd>' + pct(c.dae) + '</dd></div>' +
        '<div><dt>Comision de acordare</dt><dd>' + lei(TBI.fee) + '</dd></div>' +
        '<div><dt>Asigurare</dt><dd>' + lei(c.ins) + '</dd></div>' +
        '<div><dt>Total de plată</dt><dd>' + lei(c.total) + '</dd></div>';
      var lg = q('[data-tbi-legal]', tinfo);
      if (lg) lg.textContent = '* Exemplu reprezentativ: valoare finanțată ' + lei(c60.S) + ', 60 de luni, dobândă anuală fixă ' + pct(c60.r) +
        ', comision de acordare 95,00 lei, asigurare ' + lei(c60.ins) + ', rată lunară ' + lei(c60.pmt) +
        ', DAE ' + pct(c60.dae) + ', total de plată ' + lei(c60.total) + '.';
      qa('.msd-rm__tab', q('[data-ttabs]', m)).forEach(function (b) {
        b.classList.toggle('is-on', +b.dataset.n === tbiN);
      });
    }

    function fillTbi() {
      if (!tbi) return;
      var dlg = q('dialog.tbi-rate__modal');
      var big = tbiBig();
      var s = tbiStrong();
      var tr = q('[data-tr]', m), tag = q('[data-ttag]', m), tabs = q('[data-ttabs]', m), det = q('[data-tdet]', m);
      if (tinfo) {
        tinfo.innerHTML = '';
        if (dlg) {
          (big ? ['.tbi-rate__steps', '.tbi-rate__legal'] : ['.tbi-rate__cards', '.tbi-rate__steps', '.tbi-rate__legal'])
            .forEach(function (sel) { var e = q(sel, dlg); if (e) tinfo.appendChild(e.cloneNode(true)); });
        }
      }
      tabs.hidden = !big;
      q('[data-tlbl]', m).hidden = !big;
      det.hidden = !big;
      if (big) {
        tag.textContent = '6–60 rate';
        tag.classList.remove('msd-rm__tag--promo');
        if (!tabs.children.length) {
          TBI.terms.forEach(function (n) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'msd-rm__tab';
            b.dataset.n = n;
            b.textContent = n;
            b.setAttribute('aria-label', n + ' rate');
            b.addEventListener('click', function () { tbiN = n; renderTbiCalc(); });
            tabs.appendChild(b);
          });
        }
        renderTbiCalc();
      } else {
        tr.innerHTML = (s ? s.innerHTML : '') + ' • Dobândă: 0%';
        tag.textContent = 'Promo';
        tag.classList.add('msd-rm__tag--promo');
      }
    }

    function fill() {
      var h1 = q('.product-details h1, main h1');
      q('[data-t]', m).textContent = h1 ? h1.textContent.trim() : '';
      var pr = q('.price-meta__price', pm);
      q('[data-p]', m).innerHTML = pr ? pr.innerHTML : '';
      var im = q('.product-media img, media-gallery img, .product-information img');
      q('.msd-rm__prod img', m).src = (window.MSTRY && MSTRY.img) || (im && (im.currentSrc || im.src)) || '';
      if (inst) {
        var items = qa('.installment-simulation__item', inst).map(function (e) {
          var s2 = q('span', e), b = q('strong', e);
          return { n: s2 ? s2.textContent.trim() : '', v: b ? b.innerHTML.trim() : '' };
        });
        var tabs = q('[data-tabs]', m);
        tabs.innerHTML = '';
        items.forEach(function (it, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'msd-rm__tab';
          b.textContent = it.n;
          b.addEventListener('click', function () {
            qa('.msd-rm__tab', tabs).forEach(function (x) { x.classList.remove('is-on'); });
            b.classList.add('is-on');
            q('[data-cr]', m).innerHTML = it.v;
          });
          tabs.appendChild(b);
          if (i === items.length - 1) b.click();
        });
      }
      fillTbi();
    }

    function open(o) {
      if (o) fill();
      m.hidden = !o;
      document.documentElement.classList.toggle('msd-rm-lock', !!o);
    }

    q('.msd-rates__more', box).addEventListener('click', function () { open(true); });
    qa('[data-x]', m).forEach(function (x) { x.addEventListener('click', function () { open(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !m.hidden) open(false); });

    q('.msd-rm__atc', m).addEventListener('click', function () {
      open(false);
      var a = q('.product-details .add-to-cart-button, product-form-component [type=submit]');
      if (a) a.click();
    });
  }

  var n = 0, t = setInterval(function () {
    build();
    if (q('.msd-rates') || ++n > 30) clearInterval(t);
  }, 300);
  window.msdRatesBuild = build;
  if (document.readyState !== 'loading') build(); else document.addEventListener('DOMContentLoaded', build);
})();
/* v50: după re-randarea prețului la schimbarea variantei */
document.addEventListener('msd:live', function(){ try { (window.msdRatesBuild||function(){})(); } catch(e){} });
